import { RouterLink } from "vue-router";

const classes = [
    'vh-button',
    'vh-button-small',
    'vh-margin-xsmall-right',
];

export const Node = {

    icon: (h, { icon }) => 
    {
        return h(
            'a',
            {
                class: [
                    ...classes,
                    'vh-button-outline-default',
                ],

                disabled: true,
            },
            [
                h(
                    'i',
                    {
                        class: `${icon}`
                    }
                ),
            ]
        );
    },

    page: (h, { url, currentPage, page }) =>
    {
        return h(
            RouterLink,
            {
                class: [
                    ...classes,

                    currentPage == page
                        ? 'vh-button-primary'
                        : 'vh-button-outline-default'
                ],
                to: url,
            },
            page
        );
    },

    pageIcon: (h, { url, page, icon }) =>
    {
        return h(
            RouterLink,
            {
                class: [
                    ...classes,
                    'vh-button-outline-default',
                ],
                to: url,
                'data-tooltip': page
            },
            [
                h(
                    'i',
                    {
                        class: `${icon}`
                    }
                )
            ]
        );
    },

    showingPage: (h, { currentPage, lastPage }) =>
    {
        return h(
            'a',
            {
                class: [
                    ...classes,
                    'vh-button-primary',
                ],
                
                style:
                {
                    'color': 'white',
                },
            },
            `${currentPage} of ${lastPage}`,
        );
    },
};
